<div>
  <button appPreventDoubleClick (debounceClick)="print()" class="successBtn" [disabled]="!valid" [ngClass]="{disableButton: !valid}" *ngIf="buttonPrint">
    <fa-icon icon="print"></fa-icon> Descargar
  </button>
  <button appPreventDoubleClick class="successBtn" (debounceClick)="custom()" [disabled]="!valid"  [ngClass]="{disableButton: !valid}" *ngIf="buttonEnd">
    {{nameCustom}}
  </button>
  <button appPreventDoubleClick class="successBtn" (debounceClick)="backToMerchant()" *ngIf="goBackVisible">
    VOLVER
  </button>
  <button appPreventDoubleClick class="successBtn" (debounceClick)="pay()" [disabled]="!valid" [ngClass]="{disableButton: !valid}" *ngIf="buttonPay">
     Pagar
  </button>
</div>
